<template>
    <div class="main">
        <admin-navigation></admin-navigation>
        <div class="content-area" v-if="emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Detailed Report</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/detailed-report'" class="current">Detailed Report</router-link>
                        </li>
                    </ul>
                </div>
                <div class="actions">
                    <button @click="createAttendance" class="btn btn-success me-3">+ Add Attendance</button>
                    <button @click="getExport" class="btn btn-primary"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15L21 19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21L5 21C4.46956 21 3.96086 20.7893 3.58578 20.4142C3.21071 20.0391 3 19.5304 3 19L3 15M7 10L12 15M12 15L17 10M12 15L12 3" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Export Report</button>
                </div>
            </div>
            <div>
                <div class="searchbar">
                    <form id="getFilterDataform" action="#">
                        <div class="internalSearchBar">
                            <input class="employeeSearchBar" type="text" name="search" v-model="filterForm.search" placeholder="Search for Employees" @keyup="applyFilter" />
                        </div>
                        <div class="filters">
                            <div class="filter">
                                <div class="filter__header">
                                    <VueDatePicker v-model="filterForm.date" range :color="admin_color" format="DD/MM/YYYY" @onChange="applyFilter"><i class="fa fa-calendar-week" /></VueDatePicker>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Type</span><span class="filter__value"><span class="class-all">All</span></span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="static_qr">
                                        <input type="checkbox" name="static_qr" id="static_qr" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">QR</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="gps_checkin">
                                        <input type="checkbox" name="gps_checkin" id="gps_checkin" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Remote</label>
                                    </div>
                                    <div class="input-checkbox" data-active="false" @click="filterTypesCheckbox" data-id="qr_card">
                                        <input type="checkbox" name="qr_card" id="qr_card" value="1" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">Kiosk</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Location</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="location in locations" @click="filterLocationsCheckbox" :data-id="location.id">
                                        <input type="checkbox" name="location_id[]" :value="location.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{location.name}}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter">
                                <div class="filter__header">
                                    <span class="filter__label">Tags</span><span class="filter__value">All</span>
                                    <span class="filter__icon">
                                        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.844173 1.09143L4.66134 4.9086L8.47852 1.09143" stroke="#4F4F4F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </span>
                                </div>
                                <div class="filter__dropdown shadow">
                                    <div class="input-checkbox" data-active="false" v-for="tag in tags" @click="filterTagsCheckbox" :data-id="tag.id">
                                        <input type="checkbox" name="tag_id[]" :value="tag.id" />
                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="border" x="0.75" y="1.65929" width="16.4093" height="16.4093" rx="1.25" stroke="url(#paint0_linear)" stroke-width="1.5"></rect>
                                            <path class="checkmark" d="M13.6668 6.45709L7.25016 12.8738L4.3335 9.95709" stroke="url(#paint1_linear)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <defs>
                                                <linearGradient id="paint0_linear" x1="3.73129" y1="21.2333" x2="15.6945" y2="0.909877" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                                <linearGradient id="paint1_linear" x1="6.27804" y1="13.7389" x2="9.68752" y2="5.31402" gradientUnits="userSpaceOnUse">
                                                    <stop stop-color="#EE0979"></stop>
                                                    <stop offset="1" stop-color="#FF6A00"></stop>
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                        <label for="sample1">{{ tag.name }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="filter--reset">
                                <a href="#" @click.prevent="resetFilter"> Reset Filter</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="section mt-3 no-bg">
                <data-table :ajax="employeesAjax" :columns="employeesColumns" :order="3"></data-table>
            </div>
        </div>
        <div class="content-area" v-if="!emptyState">
            <div class="page-header">
                <div class="page-details">
                    <h2>Detailed Report</h2>
                    <ul class="breadcrumbs">
                        <li>
                            <router-link :to="'/dashboard'">Dashboard</router-link>
                        </li>
                        <li>
                            <router-link :to="'/detailed-report'" class="current">Detailed Report</router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section no-bg">
                <div class="empty-state mt-5">
                    <img :src="base_url + '/admin/img/noEmployees.svg'" />
                    <h5>No Data</h5>
                    <p>
                        Looks like there are no records
                    </p>
                </div>
            </div>
        </div>


        <div class="modal fade" id="manageAttendanceModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-show="!editMode">Add attendance</h5>
                        <h5 class="modal-title" v-show="editMode">Edit attendance</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form-error :errors="errors"></form-error>
                    <form action="#" id="manageAttendanceForm" @submit.prevent="validateAttendanceForm" enctype="multipart/form-data">
                        <div class="modal-body">
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.employee_id.$error }">
                                <label for="">Employee</label>
                                <select name="employee_id" v-model="attendanceForm.employee_id" class="form-control">
                                    <option value="">Choose employee</option>
                                    <option v-for="employee in employees" :value="employee.id">{{ employee.first_name }} {{ employee.last_name }}</option>
                                </select>
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.location_id.$error }">
                                <label for="">Location</label>
                                <select name="location_id" v-model="attendanceForm.location_id" class="form-control">
                                    <option value="">Choose location</option>
                                    <option v-for="location in locations" :value="location.id">{{ location.name }}</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="">Action Type</label>
                                <input type="radio" name="action_type" value="1" v-model="attendanceForm.action_type" /> Check In
                                <input type="radio" name="action_type" value="0" v-model="attendanceForm.action_type" /> Check Out
                            </div>
                            <div class="form-group">
                                <label for="">Attendance Type</label>
                                <input type="radio" name="attendance_type" value="static_qr" v-model="attendanceForm.attendance_type" /> QR
                                <input type="radio" name="attendance_type" value="gps_checkin" v-model="attendanceForm.attendance_type" /> Remote
                                <input type="radio" name="attendance_type" value="qr_card" v-model="attendanceForm.attendance_type" /> Kiosk
                                <input type="radio" name="attendance_type" value="admin" v-model="attendanceForm.attendance_type" /> Admin
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.action_date.$error }">
                                <label for="">Action Date</label>
                                <VueDatePicker v-model="attendanceForm.action_date" format="YYYY-MM-DD" :color="admin_color" />
                            </div>
                            <div class="form-group" :class="{ 'form-group--error': $v.attendanceForm.action_time.$error }">
                                <label for="">Action Time</label>
                                <input type="time" class="form-control" v-model="attendanceForm.action_time" />
                                <p class="text-muted">Time should be added in UTC.</p>
                            </div>
                            <div class="form-group">
                                <label for="">Latitude</label>
                                <input type="text" class="form-control" v-model="attendanceForm.latitude" />
                            </div>
                            <div class="form-group">
                                <label for="">Longitude</label>
                                <input type="text" class="form-control" v-model="attendanceForm.longitude" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-danger" @click.prevent="deleteAttendance" v-show="editMode">Delete</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormError from './FormError.vue';
import { required } from 'vuelidate/lib/validators';
export default {
    data() {
        return {
            emptyState: true,
            employeesAjax: {},
            employeesColumns: [],
            tags: {},
            locations: {},
            employees: {},
            errors: false,
            editMode: false,
            attendanceForm: new Form({
                id: "",
                employee_id: "",
                location_id: "",
                action_type: 1,
                attendance_type: "static_qr",
                action_date: null,
                action_time: "",
                latitude: "",
                longitude: "",
                _method: "post"
            }),
            filterForm: new Form({
                date: null,
                search: "",
                locations: [],
                types: [],
                tags: []
            })
        }
    },
    validations: {
        attendanceForm: {
            employee_id: {required}, location_id: {required}, 
            action_date: {required}, action_time: {required}
        }
    },
    created() {
        this.loadDataTableDetails();
        this.getTags();
        this.getLocations();
        this.getEmployees();
        this.viewAttendance();
    },
    methods: {
        getEmployees() {
            axios.get("/api/admin/organization-employees").then(response => {
                this.employees = response.data.data;
            });
        },
        validateAttendanceForm() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                if(!this.$v.required) {
                    $.alert("Please fill all requried fields.");
                }
            } else {
                if(this.editMode) {
                    this.updateAttendance();
                } else {
                    this.storeAttendance();
                }
            }
        },
        createAttendance() {
            $("#manageAttendanceForm .form-group").removeClass("form-group--error");
            this.editMode = false;
            this.attendanceForm.clear();
            this.attendanceForm.reset();
            $("#manageAttendanceModal").modal("show");
        },
        storeAttendance() {
            axios({
                method: "post",
                url: "/api/admin/attendances",
                data: this.attendanceForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAttendanceModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        },
        viewAttendance() {
            let $this = this;
            this.editMode = true;
            this.attendanceForm.clear();
            this.attendanceForm.reset();
            $(document).on("click", ".view-attendance-details", function(e) {
                e.preventDefault();
                let id = $(this).data("id");
                axios.get(`/api/admin/attendances/${id}`).then(response => {
                    let attendance_details = response.data.data;
                    $this.attendanceForm.fill(attendance_details);
                });
                $("#manageAttendanceModal").modal("show");
            });
        },
        updateAttendance() {
            this.submitStatus = 'PENDING'
            this.attendanceForm._method = "PUT";
            axios({
                method: "post",
                url: `/api/admin/attendances/${this.attendanceForm.id}`,
                data: this.attendanceForm
            }).then((response) => {
                if (response.data.status) {
                    $("#manageAttendanceModal").modal("hide");
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.refreshDataTable();
                } else {
                    Toast.fire({ icon: 'error', title: response.data.message });
                }
            }, (error) => {
                console.log(error)
            });
        },
        deleteAttendance() {
            let $this = this;
            $.confirm({
                title: 'Confirmation!',
                content: 'Are you sure to delete this attendance record?',
                buttons: {
                    confirm: {
                        btnClass: 'btn-red',
                        keys: ['enter'],
                        action: function() {
                            axios({
                                method: "delete",
                                url: `/api/admin/attendances/${$this.attendanceForm.id}`,
                            }).then((response) => {
                                if (response.data.status) {
                                    $("#manageAttendanceModal").modal("hide");
                                    Toast.fire({ icon: 'success', title: response.data.message });
                                    $this.refreshDataTable();
                                } else {
                                    Toast.fire({ icon: 'error', title: response.data.message });
                                }
                            }, (error) => {
                                console.log(error)
                            });
                        }
                    },
                    cancel: function() {
                        Toast.fire({ icon: 'success', title: "Cancelled." });
                    }
                }
            });
        },
        loadDataTableDetails() {
            this.employeesAjax = {
                url: `/api/admin/detailed-report`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },

            };

            let static_image_url = this.$root.base_url;

            this.employeesColumns = [
                {
                    name: 'User Details',
                    data: null,
                    render(data, type, row, meta) {

                        let src = `${static_image_url}/admin/img/user-avatar.jpeg`;
                        if (data.full_image_path != '') {
                            src = data.full_image_path;
                        }

                        let html = `<a href='javascript:;' data-id="${data.id}" class="user-datatable__wrapper view-attendance-details">
                                    <img class="user-datatable__img" src="${src}" />
                                    <div class="user-datatable__details">
                                        <h6>${data.full_name}</h6>
                                        <p>${data.designation} | ${data.phone}</p>
                                    </div>
                                </a>`;
                        return html;
                    },
                },
                { name: 'Action', data: 'action', orderable: true, searchable: true },
                { name: 'Time', data: 'time', orderable: true, searchable: true },
                { name: 'action_date', data: 'action_date', orderable: true, searchable: true },
                { name: 'Type', data: 'attendance_type', orderable: true, searchable: true },
                { name: 'Location', data: 'location', orderable: true, searchable: true }
            ];
        },
        refreshDataTable() {

            let locationsFilter = this.filterForm.locations.toString();
            let typesFilter = this.filterForm.types.toString();
            let tagsFilter = this.filterForm.tags.toString();

            let start_date = "", end_date = "";
            if(this.filterForm.date) {
                start_date = this.filterForm.date.start;
                end_date = this.filterForm.date.end;
            }

            let filters = `search_data=${this.filterForm.search}&types=${typesFilter}&locations=${locationsFilter}&tags=${this.filterForm.tags}&start=${start_date}&end=${end_date}`;

            this.employeesAjax = {
                url: `/api/admin/detailed-report?${filters}`,
                method: "GET",
                headers: {
                    'X-Api-Key': `Bearer ${localStorage.getItem("admin_auth")}`
                },
            };

            let options = {
                ajax: this.employeesAjax,
                scrollY: false,
                scrollX: true,
                serverSide: true,
                searching: false,
                dom: '<"top">rt<"bottom"<"left-actions"li>p><"clear">',
                columnDefs: [],
                select: {
                    style: "os",
                    selector: "td:first-child",
                },
                order: [[3, "desc"]],
                columns: this.employeesColumns,
            };

            $(".user-datatable").DataTable().destroy();

            $(".user-datatable").DataTable(options).draw();
        },
        getTags() {
            axios.get("/api/admin/tags").then(response => {
                this.tags = response.data.data;
            });
        },
        getLocations() {
            axios.get("/api/admin/locations").then(response => {
                this.locations = response.data.data.records;
            });
        },
        filterLocationsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedLocations = this.filterForm.locations;
            this.filterForm.locations = this.setCheckedCheckboxes(currentTargetValues, checkedLocations);
            this.applyFilter();
        },
        filterTypesCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedTypes = this.filterForm.types;
            this.filterForm.types = this.setCheckedCheckboxes(currentTargetValues, checkedTypes);
            this.applyFilter();
        },        
        filterTagsCheckbox(e) {
            let currentTargetValues = e.currentTarget;
            let checkedTags = this.filterForm.tags;
            this.filterForm.tags = this.setCheckedCheckboxes(currentTargetValues, checkedTags);
            this.applyFilter();
        },
        setCheckedCheckboxes(currentTargetValues, checkedOptions) {
            if (currentTargetValues.getAttribute("data-active") && currentTargetValues.getAttribute("data-id")) {
                if (currentTargetValues.getAttribute("data-active") == "false") {
                    checkedOptions.push(currentTargetValues.getAttribute("data-id"));
                } else {
                    var index = checkedOptions.indexOf(currentTargetValues.getAttribute("data-id"));
                    if (index !== -1) {
                        checkedOptions.splice(index, 1);
                    }
                }
            }
            return checkedOptions;
        },
        applyFilter() {
            this.refreshDataTable();
        },
        resetFilter() {
            this.filterForm.clear();
            this.filterForm.reset();
            this.refreshDataTable();
        },
        getExport() {

            let locationsFilter = this.filterForm.locations.toString();
            let typesFilter = this.filterForm.types.toString();
            let tagsFilter = this.filterForm.tags.toString();

            let start_date = "", end_date = "";
            if(this.filterForm.date) {
                start_date = this.filterForm.date.start;
                end_date = this.filterForm.date.end;
            }

            let params = [
                {"name": "search", "value": this.filterForm.search},
                {"name": "types", "value": typesFilter},
                {"name": "locations", "value": locationsFilter},
                {"name": "tags", "value": tagsFilter},
                {"name": "start", "value": start_date},
                {"name": "end", "value": end_date},
                {"name": "token", "value": localStorage.getItem("admin_auth")}
            ];

            window.open("/api/admin/detailed-report-excel?" + $.param(params));
        }
    },
    components: {
        FormError
    }
}

</script>
